// extracted by mini-css-extract-plugin
export var gif = "_fv-0";